import { ContainerModule } from 'inversify';
import { BadgeServiceSymbol, BadgeService } from './badge-service'
import * as Commands from './commands'

export const badgeServiceModule = new ContainerModule((bind) => {
  bind(BadgeServiceSymbol).to(BadgeService).inSingletonScope();
  bind(Commands.LoadBadgesCommand).toSelf();
  bind(Commands.CalculateBadgesCommand).toSelf();
  bind(Commands.QueryBadgesTrackingStateCommand).toSelf();
  bind(Commands.BadgesEarnedNotifier).toSelf();
});
